import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./Label.module.css";
import {
  isLoading,
  Loading,
} from "@coworker/apprestructured/src/task-management/loading";
import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";

type LabelProps = {
  value: string | Loading;
};

function Label({ value }: LabelProps) {
  if (isLoading(value)) {
    return <FixaSkeleton width="25%" height="15px" />;
  }

  return (
    <FixaText className={styles["root"]} textStyle="LabelRegular.S">
      {value}
    </FixaText>
  );
}

export default Label;
